import { FC, useEffect } from "react";
import "../styles/LoadingAnim.scss";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import userImage from "../../../assets/images/defaultAvatar.png";
import { useAppSelector } from "../../../hooks/store.hooks";
import store from "../../../store/store";
import { addBreadcrumb } from "../../../components/Breadcrumbs/reducer/breadcrumbSlice";
import { Button } from "../../../components/Button";

const EditPageButtonLink: FC<{ brandId: any; cell: any }> = ({
  brandId,
  cell,
}) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const breadcrumbHandle = async (brandId: any, cell: any) => {
    const data: any = [
      {
        label: "Brands",
        link: `/brands`,
      },
      {
        label: cell?.values?.name ? cell?.values?.name : cell?.value?.sku,
        link: `/brands/${brandId}`,
      },
    ];
    // const data: any = {};
    store.dispatch(addBreadcrumb(data));
    navigate(`/brands/edit/${brandId}`);
  };

  return (
    <Button
      onClick={() => breadcrumbHandle(brandId, cell)}
      apparence="success"
      view="default"
      type="submit"
      size="md"
    >
      <div className="font-normal text-base">Edit</div>
    </Button>
  );
};

export default EditPageButtonLink;
